export default "__VITE_ASSET__Cd7Vf5_$__"